class MinerwaInfluencer extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('.minerwa-reels__card')];
    this.videos = [...this.querySelectorAll('[data-reel]')];
    if (this.videos.length === 0) return;

    this.unmutedId = null;

    this.revealObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.revealed = 'true';
        this.revealObserver.disconnect();
      },
      { rootMargin: '-100px' },
    );
    this.revealObserver.observe(this);

    this.preloadObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const video = entry.target;
          if (video.preload !== 'auto') {
            video.preload = 'auto';
            video.load();
          }
          this.preloadObserver.unobserve(video);
        });
      },
      { rootMargin: '1000px 0px' },
    );

    this.playObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
            if (this.unmutedId === video.dataset.reelId) this.mute(video);
          }
        });
      },
      { rootMargin: '-100px' },
    );

    this.videos.forEach((video) => {
      this.preloadObserver.observe(video);
      this.playObserver.observe(video);
    });

    this.querySelectorAll('[data-sound-toggle]').forEach((button) => {
      button.addEventListener('click', () => this.toggle(button.dataset.soundToggle));
    });
  }

  disconnectedCallback() {
    this.revealObserver?.disconnect();
    this.preloadObserver?.disconnect();
    this.playObserver?.disconnect();
  }

  videoFor(id) {
    return this.videos.find((v) => v.dataset.reelId === id);
  }

  mute(video) {
    video.muted = true;
    video.closest('.minerwa-reels__card')?.removeAttribute('data-unmuted');
    this.unmutedId = null;
  }

  toggle(id) {
    const video = this.videoFor(id);
    if (!video) return;

    if (this.unmutedId === id) {
      this.mute(video);
      return;
    }

    if (this.unmutedId !== null) {
      const previous = this.videoFor(this.unmutedId);
      if (previous) this.mute(previous);
    }

    video.muted = false;
    video.closest('.minerwa-reels__card')?.setAttribute('data-unmuted', '');
    this.unmutedId = id;
  }
}

if (!customElements.get('minerwa-influencer')) {
  customElements.define('minerwa-influencer', MinerwaInfluencer);
}
